<template>
  <div
  v-if="!loading"
   class="flex items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-5 h-5"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
      />
    </svg>
    <div class="ml-1 flex items-center justify-between">
      <p class="text-base sm:text-lg ml-1 bg-markencode-blue rounded-full flex items-center justify-center text-white px-2">{{ answers }}</p>
      <p>/</p>
      <p class="text-base sm:text-lg ml-1 bg-gray-200 rounded-full flex items-center justify-center text-gray-500 px-2">{{ users }}</p>
    </div>
    
  </div>
</template>

<script>
import { sum, sortBy, findIndex } from 'lodash';

export default {
  props: ['session'],

  data() {
    return {
      loading: false,
      answers: 0,
      users: 0,
    }
  },

  mounted() {
    this.load();

    Echo.channel('markencode-app.session.' + this.session.id)
      .listen('.participant.answered', (e) => {
        this.answers++;
      })
      .listen('.participant.added', (e) => {
        this.users++;
      })
      .listen('.profile-approval.submitted', (e) => {
        this.answers = sum(Object.values(e.approvals)) || 0;
      })
  },

  methods: {
    load() {
      this.loading = true;

      window.axios
        .post(
          this.route('control-panel.user-stats', {
            sessionUuid: this.session.uuid,
          }),
          {}
        )
        .then((response) => {
          this.users = response.data.num_users;
          this.answers = response.data.num_answers;
          this.loading = false;
        })
        .catch(function (error) {
          this.loading = false;
        });
    },
  },
};
</script>
